<template>
  <div id="app" class="mx-auto overflow-hidden m-0 p-0 w-full h-auto">
    <alertInfo v-if="$store.state.alert.isAlert" />
    <NotificationCart v-if="$store.state.isAddCart" />
    <NotificationWish v-if="$store.state.isAddWish" />
    <!-- <Loading v-if="$store.state.isLoading" /> -->
    <BookLoading v-if="$store.state.isLoading" />

    <IndexAlert v-if="$store.state.isIndexAlert && $route.name === 'index'" />

    <div ref="nav" id="nav">
      <router-view name="nav"></router-view>
    </div>

    <router-view></router-view>

    <router-view name="footer"></router-view>

    <div class="toTop cursor-pointer fixed" @click="backTop" :class="{ show: isTopBtnShow }">
      <img src="@/assets/btn/topBtn.webp" class="object-contain max-w-full cursor-pointer" alt="topBtn">
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unneeded-ternary */
import IndexAlert from '@/components/modules/IndexAlert'
import alertInfo from '@/components/modules/AlertInform'
import NotificationCart from '@/components/modules/NotificationCart'
import NotificationWish from '@/components/modules/NotificationWish'
// import Loading from '@/components/modules/Loading'
import BookLoading from '@/components/modules/bookLoading'
import jump from 'jump.js'
import addCart from '@/components/modules/addCart'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  metaInfo () {
    return {
      title: 'LiveABC 互動英語教學集團 | 數位語言學習第一品牌',
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} ｜ LiveABC 互動英語教學集團` : 'LiveABC 互動英語教學集團'
      },
      htmlAttrs: {
        lang: 'zh-TW',
        amp: true
      },
      meta: [
        { vmid: 'locale', property: 'og:locale', content: 'zh_TW' }
      ]
    }
  },
  data () {
    return {
      isTopBtnShow: false
    }
  },
  mixins: [
    addCart
  ],
  watch: {
  },
  updated () {
    this.scrollEvent()
    this.setAlliance()
  },
  components: {
    alertInfo,
    NotificationCart,
    NotificationWish,
    // Loading,
    IndexAlert,
    BookLoading
  },
  created () {
  },
  computed: {
    ...mapGetters([
      'authorized',
      'cartList'
    ])
  },
  async mounted () {
    console.log('0.1.3')
    await this.$store.dispatch('updateCart')
    window.addEventListener('scroll', this.scrollEvent)
    // this.$store.state.nodeEnv !== 'production' ? this.initFB() : null // eslint-disable-line
    this.setAlliance()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollEvent)
  },

  methods: {
    // initFB () {
    //   window.fbAsyncInit = () => {
    //     FB.init({ // eslint-disable-line
    //       appId: '435564053656119',
    //       cookie: true,
    //       xfbml: true,
    //       version: 'v2.9'
    //     })

    //     FB.AppEvents.logPageView() // eslint-disable-line

    //     // // Get FB Login Status
    //     // FB.getLoginStatus(response => { // eslint-disable-line
    //     //   if (response.status === 'connected') {
    //     //     self.$store.dispatch('loginFB', { accessToken: response })
    //     //   }
    //     // })
    //   }
    // },
    scrollEvent () {
      let self = this
      if (window.pageYOffset > 250) {
        self.isTopBtnShow = true
      } else {
        self.isTopBtnShow = false
      }
    },
    backTop () {
      jump('#app', {
        duration: 1000,
        offset: 0
      })
    },
    setAlliance () {
      let self = this

      if (self.$route.query.sbid) {
        // shopback
        if (self.$route.query.utm_source && self.$route.query.utm_source === 'shopback' && self.$route.query.sbid) {
          self.$cookie.set('utm_source', 'shopback', { expires: '1M' })
          self.$cookie.set('sbid', self.$route.query.sbid, { expires: '1M' })
        }
      } else if (self.$route.query.gid) {
        // ichannels
        self.$cookie.set('utm_source', 'ichannels', { expires: '1M' })
        self.$cookie.set('ichannels', self.$route.query.gid, { expires: '1M' })
      } else {
        // 聯盟網
        if (self.$route.query.utm_source && self.$route.query.utm_medium && self.$route.query.utm_term) {
          if ((!self.$cookie.get('urm_expire')) || (self.$cookie.get('utm_term') && (self.$cookie.get('utm_term') !== self.$route.query.utm_term))) {
            self.$cookie.set('utm_source', 'affiliates', { expires: '1M' })
            self.$cookie.set('utm_medium', 'cpa', { expires: '1M' })
            self.$cookie.set('utm_term', self.$route.query.utm_term, { expires: '1M' })
          }
        }
      }
    }
  }
}

</script>
<style lang="scss">
  * {
    box-sizing: border-box;
  }
  img {
    object-fit: contain;
  }
  body {
    scroll-behavior: smooth;
    font-family: 'Noto Sans', 'Noto Sans JP', 'Noto Sans TC', 'Noto Sans SC', sans-serif;
  }
  .toTop {
    z-index: 50;
    width: 3em;
    height: 3em;
    // bottom: 14%;
    bottom: 4%;
    right: 2%;
    transition: .2s;
    opacity: 0;
    visibility: hidden;
    @media (min-width: 1024px) {
      bottom: 4%;
    }
  }
  .show {
    opacity: 1 !important;
    visibility: visible !important;
  }
</style>
